module.exports = __webpack_public_path__ + "img/icon-quote.949a0ad8.svg";